<template>
  <v-container>
    <v-layout>
      <v-form
        v-model="valid"
        ref="form"
      >
        <v-text-field
          v-model="form.name"
          label="Username"
          required
        ></v-text-field>

        <v-select
          v-model="form.type"
          :items="types"
          :rules="[v => !!v || 'Type is required']"
          label="Type"
          required
        ></v-select>

        <v-select
          v-model="form.format"
          :items="formats"
          :rules="[v => !!v || 'Format is required']"
          label="Format"
          required
        ></v-select>

        <v-btn
          :disabled="!valid"
          color="success"
          class="mr-4"
          @click="getData"
        >
          Export
        </v-btn>

        <v-alert type="info" dense style="margin-top: 1em" :value="browserwarning">
          Users with large amounts of scrobbles (&gt; 150k): Firefox works better than Chrome/Chromium
        </v-alert>

        <v-progress-linear
          v-if="progressVisible"
          class="mt-5"
          height=25
          :rounded=true
          :value=progress
          :indeterminate=progressIndeterminate
        >
          <strong>{{progressText}}</strong>
        </v-progress-linear>

        <v-overlay
          :value="nodata"
        >
          <v-btn
            color="primary"
            @click="nodata=false">
            No data found!
          </v-btn>
        </v-overlay>

      </v-form>

    </v-layout>
  </v-container>
</template>

<script>
export default {

  data: () => ({
    valid: false,
    nodata: false,
    browserwarning: false, //(window.navigator.userAgent.indexOf('Chrom')>=0),
    form: {
        name: '',
        type: 'scrobbles',
        format: 'CSV'
    },
    progressVisible: false,
    progressText: "",
    totalPages: 100,
    totalRetrieved: 0,
    types: [
      { text: 'Scrobbles', value: 'scrobbles' },
      { text: 'Loved tracks', value: 'loves' },
      //{ text: 'Events (simple)', value: '' },
      //{ text: 'Events (full)', value: '' }
    ],
    formats: [ 'CSV', 'JSON'],
  }),

  computed: {
    progress: function() {
      return Math.ceil(100 * this.totalRetrieved/this.totalPages) || 0;
    },
    progressIndeterminate: function() {
      return this.totalRetrieved == 0;
    }
  },

  methods: {
    onGot: function(form, page, pages){
      this.totalRetrieved++;
      this.totalPages = pages;
      this.setProgressText();
    },
    setProgressText: function(text){
      if (!text) {
        this.progressText = this.totalRetrieved + " of " + this.totalPages + ": " + this.progress + "%";
      }
    },
    getData: function() {
      this.totalRetrieved = 0;
      this.totalPages = 0;
      this.progressVisible = true;
      this.nodata = false;
      getAllPages(this.form, this.onGot).then(r => {
        if (!r) {
          this.nodata = true;
          this.progressVisible = false;
          return;
        }

        let   iLast = 0,
              lastTrack = null;

        do {
          lastTrack = r[0] && r[0].track[iLast],
          iLast++;
        } while (lastTrack && !lastTrack.date);

        if (!lastTrack) {
          this.nodata = true;
          this.progressVisible = false;
          return;
        }
        const lastStamp = parseInt(lastTrack.date.uts),
              typeName = typeData[this.form.type].rootItem,
              baseName = typeName + "-" + this.form.name + "-" + lastStamp;

        saveData(r, this.form, baseName);
        this.progressVisible = false;
      })
    }
  }
};

const axios = require('axios');
const retryInterceptor = require('axios-retry-interceptor');
const FileSaver = require('file-saver');

const lfm = axios.create({
        baseURL: 'https://ws.audioscrobbler.com/2.0',
        method: 'get',
      }),
      lfmRetry = axios.create({
        baseURL: 'https://ws.audioscrobbler.com/2.0',
        method: 'get',
      });

const typeData = {
  scrobbles: {
    key: 'scrobbles',
    label: 'Scrobbles',
    method: 'user.getRecentTracks',
    rootItem: 'recenttracks'
  },
  loves: {
    key: 'loves',
    label: 'Loved tracks',
    method: 'user.getLovedTracks',
    rootItem: 'lovedtracks'
  }
};

retryInterceptor(lfmRetry, {
  maxAttempts: 5,
  waitTime: 5000,
  errorCodes: [404, 500, 501, 502, 503, 504],
  onRetry: function(error){
    console.warn("Performing retry " + error.config.__retryCount);
  }
});

async function getPage(form, page, cb, lfm){
  const ret = await lfm.get('/', {
    params: {
      api_key: "65fb65f79427db8ce5626269c0d7fa2b",
      format: (form.format=='XML'?'xml':'json'),
      method: typeData[form.type].method,
      limit: 200,
      user: form.name,
      page: page
    }
  });

  const res = ret.data[typeData[form.type].rootItem],
        pages = res['@attr'].totalPages;

  if (cb) cb(form, page, pages);
  return res;
}

async function getAllPages(form, cb){
  try{
    const res = await getPage(form, 1, cb, lfm),
          pages = res['@attr'].totalPages,
          promises = [res];

    for (var i=2;i<=pages;i++){
      //single thread traag maar betrouwbaar
      promises.push(await getPage(form, i, cb, lfmRetry));
      //multi-thread maar browsers hebben problemen met heel veel promises tegelijk
      //promises.push(getPage(form, i, cb, lfmRetry));
    }

    return Promise.all(promises);

/*
    const myCoolFunction = (max, i) => {
      const throttleTime = 100 // in milliseconds
      if (i <= max) {
        console.log("Queuing request for page "+ i);
        promises.push(getPage(form, i, cb, lfmRetry));
        i++;
        setTimeout(myCoolFunction, throttleTime, pages, i);
      }
      if (i > max){
        console.log("myCoolFunction done");
        return Promise.all(promises);
      }
    };

    return myCoolFunction(pages,2);
*/

  } catch(e) {
    console.log(e);
  }

}

function saveData(data, form, fn) {

  if (form.format == "CSV"){
    var lines = [["uts", "utc_time", "artist", "artist_mbid", "album", "album_mbid", "track", "track_mbid"].join(",") + "\r\n"];
    data.forEach(function(tracks){
      tracks.track.forEach(function(track){
        if (track.date){
          lines.push([
            csv(track.date.uts),
            csv(track.date['#text']),
            csv(form.type=="scrobbles"?track.artist['#text']:track.artist.name),
            csv(track.artist.mbid),
            csv(form.type=="scrobbles"?track.album['#text']:""),
            csv(form.type=="scrobbles"?track.album.mbid:""),
            csv(track.name),
            csv(track.mbid)
          ].join(",") + "\r\n");
        }
      });
    });
    const csvblob = new Blob(lines, {type: "text/csv"});
    return FileSaver.saveAs(csvblob, fn + ".csv");
  }


  if (form.format == "JSON") {
    const blob = new Blob([JSON.stringify(data)], {type: "application/json"});
    return FileSaver.saveAs(blob, fn + ".json");
  }

}

function csv(val){
  if (val)
    return "\"" + (val).toString().replace(/"/g, "\"\"") + "\"";
  else
    return "\"\"";
}

/* Start Event scraping
function startEventScrape(form, username, format, exportType){
    var baseUrl = "https://www.last.fm",
        years = [{year: "", url: baseUrl+"/user/"+username+"/events"}],
        pagPages = [],
        yearPages = [],
        entries = [],
        entryPages = [],
        lineupPages = [],
        events = [];

    if (window.DOMParser) {
        var parser = new DOMParser();
    } else if (window.ActiveXObject) {
        alert("Sorry, real browsers only");
        return;
    }

    //UI state init
    //$("#inputbar input, #inputbar select, #inputbar button")
      //.attr("disabled", true);

    //$("#start").hide();
    //$("#error").hide();
    //$("#content").fadeOut();



    $(".progress-label").text("Starting...");
    $("#progress").progressbar({
      value: false
    }).show();

    //create list of index-urls
    for (var yr = 1980; yr <= (new Date().getFullYear()); yr++){
      years.push({
        year: yr,
        url: baseUrl+"/user/"+username+"/events/"+yr
      });
    }

    //add pagination pages to list of index-urls
    $(years).each(function(idx, itm){
      pagPages.push($.get("/common/proxy.php", { mode: "native", url: itm.url }).done(function(data){
        return scrapePagination(data, itm);
      }));
    });

    //when list of index-pages complete, then scrape index-pages
    $.when.apply(this, pagPages).then(function(data){
      $(years).each(function(idx, itm){
        yearPages.push($.get("/common/proxy.php", { mode: "native", url: itm.url }).done(function(data){
          return scrapeIndex(data, itm)
        }));
      });

      $.when.apply(this, yearPages).then(function(data){
        $(entries).each(function(index, itm){
          entryPages.push($.get("/common/proxy.php", {mode: "native", url: baseUrl+itm.href}).done(function(data){
            return scrapeEvent(data, itm);
          }));
        });

        $.when.apply(this, entryPages).then(function(data){
          $(events).each(function(index, itm){
            if (exportType == 'events-full' && itm.fullLineupLink) {
              itm.artists = [];
              for (var idx=1; idx <= itm.pageCount; idx++){
                lineupPages.push($.get("/common/proxy.php", {mode: "native", url: baseUrl+itm.fullLineupLink + '?page=' + idx}).done(function(data){
                  return scrapeLineup(data, itm, idx);
                }));
              }
            }
          });

          $.when.apply(this, lineupPages).then(function(data){
            var trk = ['/export', format, exportType, username].join("/");
            ga('send', 'pageview', trk);

            //console.log(events);
            if (format == "csv"){
              var header = (exportType=='events-full'?[["date", "title", "artist", "venue", "place", "country", "type", "href"].join(",") + "\r\n"]
                                              :[["date", "title", "artists", "venue", "place", "country", "type", "href", "isFullLineup"].join(",") + "\r\n"]),
                  lines  = [];
              events.forEach(function(e){
                if (exportType =='events-full') {
                  e.artists.forEach(function(a){
                    lines.push([
                      csv(e.startdate),
                      csv(e.title),
                      csv(a.name),
                      csv(e.venue?e.venue.name:""),
                      csv(e.venue?e.venue.place:""),
                      csv(e.venue?e.venue.country:""),
                      csv(e.href.split("/")[1]),
                      csv(baseUrl + e.href)
                    ].join(",") + "\r\n");
                  });
                } else {
                  lines.push([
                    csv(e.startdate),
                    csv(e.title),
                    csv(_.pluck(e.artists, "name").sort().join(",")),
                    csv(e.venue?e.venue.name:""),
                    csv(e.venue?e.venue.place:""),
                    csv(e.venue?e.venue.country:""),
                    csv(e.href.split("/")[1]),
                    csv(baseUrl + e.href),
                    csv((e.fullLineupLink?"false":"true"))
                  ].join(",") + "\r\n");
                }
              });

              var data = header.concat(lines.sort()),
                  blob = new Blob(data, {type: "text/csv"});
              saveAs(blob, exportType + "-" + username + ".csv");
            }

            if (format == "json") {
              var blob = new Blob([JSON.stringify(events)], {type: "application/json"});
              saveAs(blob, "events-" + username + ".json");
            }

            if (format == "xml") {
              var xmlText = [json2xml(events)],
                  blob = new Blob(xmlText, {type: "text/xml"});
              saveAs(blob, "events-" + username + ".xml");
            }

            cleanup(true);
          });
        });
      });
    });

    function scrapeEvent(data, itm){
      //scrape all relevant data per event into an object and push it into the events array;
      var doc = parser.parseFromString (data, "text/html");
      if(!doc) {
        console.log(data);
        return; //something wrong, a shame, but ignore.
      }

      report("", "Scraping event " + itm.name);

      var evt = {
        title: itm.name,
        href: itm.href,
        artists: []
      };

      //get startdate
      var dt = doc.evaluate("//section[@class='event-detail']//*[@itemprop='startDate']/@content", doc, null, 2, null).stringValue;
      if (dt) evt.startdate = dt.substring(0,10);

      //get venue name
      var vname = doc.evaluate("//section[@class='event-detail' and @itemprop='location']/p[@class='event-detail-address']/*[@itemprop='name']/text()", doc, null, 2, null).stringValue;
      var vplace = doc.evaluate("//section[@class='event-detail' and @itemprop='location']/p[@class='event-detail-address']//*[@itemprop='addressLocality']/text()", doc, null, 2, null).stringValue;
      var vcountry = doc.evaluate("//section[@class='event-detail' and @itemprop='location']/p[@class='event-detail-address']//*[@itemprop='addressCountry']/text()", doc, null, 2, null).stringValue;
      if (vname) {
        evt.venue = {
          name: vname,
          place: vplace,
          country: vcountry
        };
      }

      //get some artists from lineup
      var more = doc.evaluate("//section[@id='line-up']//p[@class='more-link']/a", doc, null, 9, null).singleNodeValue;
          c = doc.evaluate("//section[@id='line-up']/h2/text()", doc, null, 2, null).stringValue;

      if (more) {
        evt.fullLineupLink = more.getAttribute("href");
        evt.pageCount = Math.ceil(c.substring(c.indexOf("(")+1,c.indexOf(")"))/15);
      }

      var artists = doc.evaluate("//section[@id='line-up']//p[@class='grid-items-item-main-text']/a", doc, null, 0, null);
      if (artists.iterateNext) {
        var artist = artists.iterateNext();
        while(artist) {
          evt.artists.push({name: artist.textContent, href: artist.getAttribute("href")});
          artist = artists.iterateNext();
        }
      }

      events.push(evt);
    }

    function scrapeIndex(data, itm){
      var doc = parser.parseFromString (data, "text/html");
      if(!doc) {
        console.log(data);
        return; //something wrong, a shame, but ignore.
      }

      var currentYear = doc.evaluate("//div[contains(@class, 'content-top-lower')]//a[contains(@class, 'secondary-nav-item-link--active')]/text()", doc, null, 2, null).stringValue.trim();
      if (currentYear) {
        //console.log("retrieved events for " + currentYear);
        report("", "Found events for " + currentYear + " ...");
        var rows = doc.evaluate("//table[@class='events-list']/tbody/tr[contains(@class,'events-list-item')]", doc, null, 0, null);
        var row = rows.iterateNext();
        while(row) {
          var rowDoc = parser.parseFromString(row.outerHTML, "text/html"),
              lnk = rowDoc.evaluate("//div[@class='events-list-item-event--title']/a", rowDoc, null, 9, null).singleNodeValue;
          if (lnk) {
            entries.push({name: lnk.text.trim(), href: lnk.getAttribute("href")});
          }
          else console.log(row.outerHTML);
          row = rows.iterateNext();
        };
      }
    }

    function scrapePagination(data, itm){
      report("", "Looking for events attended in " + itm.year);
      var doc = parser.parseFromString (data, "text/html");
      if(!doc) {
        console.log(data);
        return; //something wrong, a shame, but ignore.
      }
      var otherPages = doc.evaluate("//li[contains(@class,'pagination-page')]/a/@href", doc, null, 0, null),
          otherPage = otherPages.iterateNext();
      while (otherPage){
        years.push({year: itm.year, url: itm.url + otherPage.value});
        otherPage = otherPages.iterateNext();
      }
    }

    function scrapeLineup(data, itm){
      report("", "Scraping full lineup for " + itm.title + " (" + itm.pageCount + " pages)");
      var doc = parser.parseFromString (data, "text/html");
      if(!doc) {
        console.log(data);
        return; //something wrong, a shame, but ignore.
      }

      var list = doc.evaluate("//h3[@class='big-artist-list-title' and @itemprop='name']/a", doc, null, 0, null),
          a = list.iterateNext();

      while(a){
        itm.artists.push({name: a.textContent, href: a.getAttribute("href")});
        a = list.iterateNext();
      }

    }

} //end startEventScrape
  */

</script>
